module.exports = __webpack_public_path__ + "static/media/lingolink-5.f408221a.jpg";